import React, { useState, useEffect } from "react";
import API from "./adminAxios";
import { toast } from "react-toastify";
import { FaTools } from "react-icons/fa";

export default function MaintenancePanel() {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get("/super-admin/maintenance-status")
      .then(res => setIsMaintenance(res.data.isMaintenance))
      .catch(() => {});
  }, []);

  const toggleMaintenance = async () => {
    try {
      setLoading(true);
      const res = await API.post("/super-admin/toggle-maintenance");
      setIsMaintenance(res.data.isMaintenance);
      toast.success(res.data.message || "Maintenance mode updated successfully!");
    } catch (err) {
      toast.error("Failed to update maintenance state");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "600px", fontFamily: "'Inter', sans-serif" }}>
      <h2 style={{ color: "#fff", marginBottom: "8px", fontSize: "24px" }}>System Maintenance Mode</h2>
      <p style={{ color: "#94a3b8", marginBottom: "25px", fontSize: "14px" }}>Control global app access and lock out platform traffic during routine deployments.</p>
      
      <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "30px", borderRadius: "20px", border: "1px solid rgba(255,255,255,0.05)" }}>
        <FaTools size={32} color="#00f2ff" style={{ marginBottom: "15px" }} />
        <h3 style={{ color: "#fff", margin: "0 0 10px" }}>Current Status: <span style={{ color: isMaintenance ? "#ef4444" : "#10b981" }}>{isMaintenance ? "ACTIVE (LOCKED)" : "ONLINE (NORMAL)"}</span></h3>
        <p style={{ color: "#94a3b8", fontSize: "13px", marginBottom: "20px" }}>When maintenance mode is active, user portals will redirect to the maintenance notice screen.</p>
        <button 
          onClick={toggleMaintenance} 
          disabled={loading}
          style={{ padding: "14px 24px", background: isMaintenance ? "#10b981" : "#ef4444", color: "#fff", border: "none", borderRadius: "12px", fontWeight: "800", cursor: "pointer" }}
        >
          {loading ? "PROCESSING..." : (isMaintenance ? "Disable Maintenance Mode" : "Enable Maintenance Mode")}
        </button>
      </div>
    </div>
  );
}